export default __webpack_public_path__ + "static/media/science-img-three.98ab6878.svg";